<template>
  <div class="list">
    <div v-if="!isMobile">
      <div class="sticky" v-if="showFixedHeader">
        <table :class="{'table-loading':loading}">
          <thead>
            <th>#</th>
            <th>Promo Code</th>
            <th>Status</th>
            <th>Redeemed by</th>
            <th>Redeemed Date</th>
            <th>Expiration Date</th>
          </thead>
          <tbody>
            <tr v-for="promo in promos">
              <td>{{ promo.placed }}</td>
              <td>{{ promo.promoCode }}</td>
              <td>{{ promo.status }}</td>
              <td><a :href="'/#/consumer/' + promo.conID" class="und" target="_blank">{{ promo.conID }}</a></td>
              <td>{{ promo.redeemedDate }}</td>
              <td>{{ promo.expirationDate }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <table :class="{'table-loading':loading}">
        <thead>
          <th>#</th>
          <th>Promo Code</th>
          <th>Status</th>
          <th>Redeemed by</th>
          <th>Redeemed Date</th>
          <th>Expiration Date</th>
        </thead>
        <tbody>
          <tr v-for="promo in promos">
            <td>{{ promo.placed }}</td>
            <td>{{ promo.promoCode }}</td>
            <td>{{ promo.status }}</td>
            <td><a :href="'/#/consumer/' + promo.conID" class="und" target="_blank">{{ promo.conID }}</a></td>
            <td>{{ promo.redeemedDate }}</td>
            <td>{{ promo.expirationDate }}</td>
          </tr>

          <tr v-show="loading && !promos.length">
            <td class="table-block" colspan="6">
              <transition name="slide-up">
                <div class="loader" v-show="loading">
                  <div>
                    <i class="fas fa-spinner fa-spin"></i>
                    Loading...
                  </div>
                </div>
              </transition>
            </td>
          </tr>

          <tr v-show="!loading && !promos.length">
            <td colspan="6" class="table-block">
              <transition name="slide-up">
                <div v-show="promos.length === 0 && !loading" class="empty-result">
                  <i class="far fa-frown-open fa-3x"></i><br/>
                  No record found!
                </div>
              </transition>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="cards">
      <div v-show="loading && !promos.length">
        <transition name="slide-up">
          <div class="loader" v-show="loading">
            <div>
              <i class="fas fa-spinner fa-spin"></i>
              Loading...
            </div>
          </div>
        </transition>
      </div>

      <div v-show="!loading && !promos.length">
        <transition name="slide-up">
          <div v-show="promos.length === 0 && !loading" class="empty-result">
            <i class="far fa-frown-open fa-3x"></i><br/>
            No record found!
          </div>
        </transition>
      </div>

      <div class="card" v-for="promo in promos" :key="promo.id">
        <div class="title">
          <div class="label">#{{ promo.placed }}</div>
        </div>
        <div class="title">
          <div class="label">Promo Code:</div>
          <div class="value">{{ promo.promoCode }}</div>
        </div>
        <div class="title">
          <div class="label">Status:</div>
          <div class="value">{{ promo.status }}</div>
        </div>
        <div class="title">
          <div class="label">Redeemed by:</div>
          <div class="value"><a :href="'/#/consumer/' + promo.conID" class="und" target="_blank">{{ promo.conID }}</a></div>
        </div>
        <div class="title">
          <div class="label">Redeemed Date:</div>
          <div class="value">{{ promo.redeemedDate }}</div>
        </div>
        <div class="title">
          <div class="label">Expiration Date:</div>
          <div class="value">{{ promo.expirationDate }}</div>
        </div>
      </div>
    </div>

    <div class="fix-footer">
      <div class="row">
        <div class="small-3 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span>per page</span>
        </div>

        <div class="small-6 columns page-data">
          <span v-show="promos.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div class="small-3 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiPromo from '@/modules/api/promo'
export default {
  name: 'promo-view-list',
  props: [ 'showFixedHeader', 'isMobile' ],
  components: {},
  data () {
    return {
    }
  },
  computed: {
    promos () { return this.$store.state.promo.view.list },
    loading () { return this.$store.state.promo.view.loading },
    currentOrder () {
      let promo = this.$store.state.promo.view
      return { field: promo.order, asc: promo.orderAsc }
    },
    perPage: {
      get: function () { return this.$store.state.promo.view.perPage },
      set: function (value) {
        this.$store.commit('promo/setViewPerPage', parseInt(value))
        this.$store.commit('promo/setViewCurrentPage', 1)
        this.getPromo()
      }
    },
    pageData () {
      let tableData = this.$store.state.promo.view
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    currentPage: {
      get: function () { return this.$store.state.promo.view.currentPage },
      set: function (value) {
        this.$store.commit('promo/setViewCurrentPage', parseInt(value))
        this.getPromo()
      }
    },
    isLastPage () {
      let promo = this.$store.state.promo.view
      return (promo.currentPage * promo.perPage) >= promo.maxList
    },
    totalPage () {
      let promo = this.$store.state.promo.view
      return Math.ceil(promo.maxList / promo.perPage)
    }
  },
  methods: {
    init () {
    },
    getPromo () {
      let self = this
      self.$store.commit('promo/setViewLoading', true)
      let id = self.$route.params.id
      ApiPromo.getViewList(self, id, function (res) {
        self.$store.commit('promo/setViewLoading', false)
      })
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('promo/setViewCurrentPage', this.$store.state.promo.view.currentPage - 1)
      this.getPromo()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('promo/setViewCurrentPage', this.$store.state.promo.view.currentPage + 1)
      this.getPromo()
    },
    sort (field) {
      let self = this
      if (self.loading) { return }
      let promo = self.$store.state.promo.view
      if (field !== promo.order) {
        self.$store.commit('promo/setViewOrder', 1)
      } else {
        self.$store.commit('promo/setViewOrderAsc', promo.orderAsc === 1 ? 0 : 1)
      }
      self.$store.commit('promo/setViewOrder', field)
      self.getPromo()
    }
  },
  watch: {
    // brandFormShow: function (value) {},
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.sticky{
  position: fixed;
  top: 0;
  right: 0;
  width: 60%;
  overflow: hidden;
  height: 30px;
  z-index: 3;
}
table{
  border-collapse: collapse;
  width: 100%;
  transition: all .5s ease;
  margin-bottom: 49px;
  &.table-loading{ opacity: .7; }
  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;
    th{ padding: 5px 10px; }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;
      i{ margin-left: 2px; }
    }
  }
  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);
      &:hover { background: #e3e7e8!important; }
      &:nth-of-type(even) { background: #fbfbfb; }
      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;
        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;
          .fa{ color: #ccc; }
        }
      }
    }
  }
  a{ cursor: pointer; }
}
.fix-footer{
  position: fixed;
  bottom: 0;
  right: 0;
  width: 60%;
  height: 50px;
  background: #eaeaea;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;
  .row{ max-width: 100%; }
  select{
    max-width: 100px;
    height: 30px;
    padding: 5px;
  }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 10px 0;
    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 10px 0;
  }
  .pagination{
    text-align: right;
    padding: 10px 10px;
    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;
      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }
}
@media only screen and (max-width: 430px) {
  .cards {
    padding: 60px 0 100px 0;
    .card {
      border: 1px solid #ccc;
      margin: 0 10px;
      margin-bottom: 15px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      padding: 10px;
      padding-bottom: 5px;
      
      > div {
        margin-bottom: 3px;
      }
  
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
        .name {
          font-weight: 900;
        }
        .amount {
          margin-left: 5px;
          font-size: 14px;
        }
        .status {
          text-transform: uppercase;
          font-size: 14px;
          font-weight: 900;
          .und {
            &.deactivate {
              color: #ccc;
            } 
            text-decoration: underline; 
          }
        }
      }
  
      .title {
        display: flex;
        align-items: center;
      }
  
      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }
  
      .value {
        margin-right: 10px;
        font-size: 14px;
        font-weight: 900;
      }
      .actions {
        width: 100%;
        background: #f3f3f3;
        border-top: 1px solid #ccc;
        padding: 15px 10px;
        text-align: center;
        margin-top: 15px;
        border-radius: 0 0 10px 10px;
        margin-bottom: 0;
        .button {
          line-height: 14px;
          font-size: 14px;
          padding: 10px 18px 9px;
        }
      }
    }
  }
  .fix-footer {
    bottom: 45px;
    left: 0;
    width: 100%;
    .row {
      display: flex;
      justify-content: space-between;
    }
    .per-page {
      width: auto;
      select {
        width: 55px;
      }
      span:nth-child(3) {
        display: none;
      }
    }
    .page-data {
      display: none;
    }
    .pagination {
      display: flex;
      align-items: center;
      margin-right: 15%;
      select {
        width: 55px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Promo/PromoViewList.vue